import { render, staticRenderFns } from "./ChatAudio.vue?vue&type=template&id=73830357&scoped=true"
import script from "./ChatAudio.vue?vue&type=script&lang=js"
export * from "./ChatAudio.vue?vue&type=script&lang=js"
import style0 from "./ChatAudio.vue?vue&type=style&index=0&id=73830357&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73830357",
  null
  
)

export default component.exports